import { createApp } from "vue";
import { createPinia } from "pinia";
import App from "@/App.vue";
import router from "@/router";
import "@/scss/index.scss";
import "@packages/component-library/style.css";
import "@packages/fonts-library/style.css";
import "@packages/kursir-icons/style.css";
import { setDefaultOptions } from "date-fns";
import { createHead } from "@unhead/vue";
import { ru } from "date-fns/locale";

import "swiper/css";

const app = createApp(App);
const head = createHead();

app.use(createPinia());
app.use(router);
app.use(head);

setDefaultOptions({ locale: ru });

app.mount("#app");
